/**
 * Convert viewport width to a skapa size.
 * @param viewportWidth Inner width of the viewport.
 * @returns A skapa size.
 */
export const widthToSkapaSize = (viewportWidth) => {
    if (viewportWidth < 600) {
        return 'S';
    }
    if (viewportWidth < 900) {
        return 'M';
    }
    if (viewportWidth < 1200) {
        return 'L';
    }
    if (viewportWidth < 1600) {
        return 'XL';
    }
    return 'XXL';
};
export const shouldShowSidebar = (viewportWidth) => {
    const skapaSize = widthToSkapaSize(viewportWidth);
    if (skapaSize === 'XL' || skapaSize === 'XXL') {
        return true;
    }
    return false;
};
//# sourceMappingURL=viewportSize.js.map